import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';

export const setSortingPreferences = (sortBy: string): void => {
  const searchParams = new URLSearchParams(window.location.search);

  // we set url and localstorage if different from existing values
  if (searchParams.get('sort_by') !== sortBy) {
    searchParams.set('sort_by', sortBy as string);

    window.history.pushState(
      null,
      '',
      `${window.location.pathname}?${searchParams.toString()}`.replaceAll('%3A', ':'),
    );
  }

  if (LocalStorage.get('recordingSortingPreferences') !== sortBy) {
    LocalStorage.set('recordingSortingPreferences', sortBy);
  }
};
